// @ts-nocheck
/**
 * Explore tab: the search bar and quick filter chips open the site search (assets/vhp-search.js, Algolia),
 * hearts on liked tiles, opened circles show as seen, range tiles (sections/vhp-explore-ranges.liquid) get their
 * recipe counts from the Algolia records (assets/vhp-search-core.js) and open the search like the quick chips.
 * The personal rows ("Passt zu deinem Ziel", "Schnell & proteinreich", "Proteinbomben") were removed 2026-11-02.
 *
 * Collections: category circles, collection cards, "Alle ansehen" and the directory's categories open that
 * collection's page (sections/vhp-main-collection.liquid; its recipe cards play the collection in the reel,
 * assets/vhp-collection-grid-reel.js). A link with data-explore-feed opens that collection (the meal cards and
 * directory rows point at the slot-based planner collections, the ones their counts come from).
 * Recipes open on top of Explore, which stays as it was underneath (scroll, rows): a row tile plays its row in the
 * video reel (assets/vhp-reel-viewer.js) from the tapped recipe: Neu / Viral the whole collection. A plain recipe
 * link opens the recipe sheet. Back / the reel's arrow lands on Explore again.
 * The collection counts are the recipes this visitor actually gets (the server's products_count also counts
 * exclusive and non-recipe products). Without the reel (or on any failure): the swipe deck (/?set=explore).
 * Without JS the bar is a plain form to /search and everything below is server-rendered links.
 */
(() => {
  'use strict';

  const tr = window.vhpT; // snippets/vhp-i18n.liquid

  const root = document.querySelector('[data-explore]');
  if (!root || root.dataset.exploreBound === '1') return;
  root.dataset.exploreBound = '1';

  const SET_KEY = 'vhp_explore_set';
  const MAX_SET = 40;

  const input = root.querySelector('[data-explore-input]');
  const form = root.querySelector('[data-explore-form]');
  const main = root.closest('main') || document.body;

  const esc = (value) =>
    String(value == null ? '' : value).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const articleUrl = (handle) => `/blogs/rezepte/${encodeURIComponent(handle)}`;
  const rootUrl = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const track = (name, params) => {
    if (typeof window.vhpTrack === 'function') window.vhpTrack(name, params);
  };

  /* ---------------------------------------------------------------- search entry */

  // The bar looks like a search field; focusing it moves straight into the full search.
  input?.addEventListener('focus', () => {
    if (!window.vhpSearch) return;
    input.blur();
    window.vhpSearch.open();
  });
  form?.addEventListener('submit', (event) => {
    if (!window.vhpSearch) return;
    event.preventDefault();
    window.vhpSearch.open({ view: 'results', q: input.value.trim() });
  });

  /* ---------------------------------------------------------------- likes */

  const likedHandles = () => {
    try {
      return new Set((window.vhpPlannerLikes?.read().likes.items || []).map((item) => item.handle).filter(Boolean));
    } catch (_) {
      return new Set();
    }
  };

  // Server-rendered tiles (Neu / Viral rows) and our own: a small heart on recipes already liked.
  const paintLiked = () => {
    const liked = likedHandles();
    main.querySelectorAll('.ex-tile[data-handle]').forEach((tile) => {
      tile.classList.toggle('is-liked', liked.has(tile.dataset.handle));
    });
  };

  /* ---------------------------------------------------------------- range tiles */

  // "40 g+ Protein" / "300–400 kcal" tiles (sections/vhp-explore-ranges.liquid): recipe count from the records.
  const paintRangeCounts = () => {
    const records = window.vhpSearchCore?.data()?.rows;
    if (!records) return;
    main.querySelectorAll('.ex-range[data-quick]').forEach((tile) => {
      const out = tile.querySelector('[data-range-count]');
      const [key, value] = tile.dataset.quick.split(/:(.*)/);
      if (!out || key === 'sort') return;
      const state = { [key]: key === 'kcal' ? value : Number(value) };
      const count = records.filter((row) => window.vhpSearchCore.passes(row, state)).length;
      out.textContent = tr('common.recipes', { n: count });
    });
  };

  /* ---------------------------------------------------------------- seen story rings */

  // Category circles behave like stories: opened ones lose their ring and move behind the unseen ones,
  // until the collection gets new recipes (count above the one stored when it was opened).
  const SEEN_KEY = 'vhp_explore_seen_v1';
  const readSeen = () => {
    try {
      return JSON.parse(localStorage.getItem(SEEN_KEY) || '{}') || {};
    } catch (_) {
      return {};
    }
  };
  const circleHandle = (circle) => (circle.getAttribute('href') || '').match(/\/collections\/([a-z0-9-]+)/)?.[1] || '';
  const markSeen = (handle, count) => {
    const seen = readSeen();
    seen[handle] = Number(count) || 0;
    try {
      localStorage.setItem(SEEN_KEY, JSON.stringify(seen));
    } catch (_) {}
  };
  const paintSeen = () => {
    const seen = readSeen();
    const circles = Array.from(main.querySelectorAll('a.vhp-story-circle[href]'));
    circles.forEach((circle) => {
      const handle = circleHandle(circle);
      const count = Number(circle.dataset.count) || 0;
      circle.classList.toggle('is-seen', handle in seen && count <= seen[handle]);
    });
    const track = circles[0]?.parentElement;
    if (!track || circles.some((circle) => circle.parentElement !== track)) return;
    // Stable: unseen first in their curated order, then the seen ones.
    circles
      .filter((circle) => !circle.classList.contains('is-seen'))
      .concat(circles.filter((circle) => circle.classList.contains('is-seen')))
      .forEach((circle) => track.append(circle));
  };

  /* ---------------------------------------------------------------- collection counts */

  // The recipes each collection really plays for this visitor (rows: subscribers include the exclusives).
  const paintCounts = () => {
    const rows = window.vhpSearchCore?.data()?.rows;
    if (!rows || !rows.some((row) => row.cols?.length)) return;
    const counts = new Map();
    rows.forEach((row) => (row.cols || []).forEach((handle) => counts.set(handle, (counts.get(handle) || 0) + 1)));
    main.querySelectorAll('a[href*="/collections/"]').forEach((link) => {
      const n = counts.get(collectionOf(link));
      if (!n) return;
      if (link.matches('.vhp-story-circle')) link.dataset.count = n;
      const card = link.querySelector('.ex-card__count');
      if (card) card.textContent = tr('common.recipes', { n });
      const dir = link.querySelector('.explore-dir__count');
      if (dir) dir.textContent = n;
    });
  };

  /* ---------------------------------------------------------------- reel */

  // The collection a link plays: its data-explore-feed (the meal cards and rows point at the slot-based planner
  // collections), else /collections/{handle} itself (not a product or filter path under it).
  const collectionOf = (link) => {
    if (link.dataset.exploreFeed) return link.dataset.exploreFeed;
    try {
      const url = new URL(link.href, location.href);
      return url.origin === location.origin ? url.pathname.match(/^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/collections\/([a-z0-9-]+)\/?$/)?.[1] || '' : '';
    } catch (_) {
      return '';
    }
  };

  // The tile of a recipe on screen, for the reel to zoom out of and back into: in the row it was opened from,
  // else anywhere on Explore; else the card / circle that opened it.
  const tileOf = (handle, scope) => {
    const sel = `.ex-tile[data-handle="${CSS.escape(handle)}"]`;
    return scope?.querySelector(sel) || main.querySelector(sel);
  };

  let opening = 0;
  // One tap at a time: the last one wins, an earlier one still loading is dropped.
  const openReel = async ({ opener, collection, start, title, source, scope, fallback }) => {
    const token = ++opening;
    main.querySelectorAll('.is-opening').forEach((el) => el.classList.remove('is-opening'));
    opener.classList.add('is-opening');
    try {
      if (!collection) throw new Error('no collection');
      const items = await window.vhpReelViewer.collection(collection);
      if (token !== opening) return;
      if (!root.isConnected) return; // another tab took over meanwhile (assets/app-router.js)
      const viewer = window.vhpReelViewer;
      if (!viewer || !items.length) throw new Error('no reel');
      const index = Math.max(0, items.findIndex((item) => item.handle === start));
      track('explore_reel_open', { source, collection: collection || '', start: items[index].handle, size: items.length });
      viewer.open({
        items,
        start: index,
        title,
        label: tr('explore.as_videos', { title }),
        source: `explore_${source}`,
        ...(root.dataset.subscriber === 'true' && window.vhpPlanPicker
          ? { onPlan: (item) => window.vhpPlanPicker.open(item, { source: 'explore_reel' }) }
          : {}),
        originFor: (item) => tileOf(item.handle, scope) || (item.handle === items[index].handle ? opener : null),
        onClose: () => paintLiked(),
      });
      // Grey ring once open; it moves behind the unseen circles on the next visit, not under the finger.
      if (source === 'circle') opener.classList.add('is-seen');
    } catch (_) {
      if (token === opening) fallback();
    } finally {
      if (token === opening) opener.classList.remove('is-opening');
    }
  };

  // Finger down on a row tile: its row's recipe list and the first video start loading.
  main.addEventListener(
    'pointerdown',
    (event) => {
      const tile = event.target instanceof Element ? event.target.closest('[data-explore-open]') : null;
      if (!tile) return;
      const collection = tile.closest('[data-explore-set]')?.dataset.setCollection;
      if (collection) window.vhpReelViewer?.collection(collection).catch(() => {});
      window.vhpReelViewer?.prefetch(tile.dataset.handle);
    },
    { passive: true }
  );

  /* ---------------------------------------------------------------- open in feed (fallback) */

  const openInFeed = (handles, start, label) => {
    const list = handles.slice(0, MAX_SET);
    if (!list.includes(start)) list.unshift(start);
    try {
      sessionStorage.setItem(SET_KEY, JSON.stringify({ handles: list, start, label, at: Date.now() }));
    } catch (_) {
      window.location.href = articleUrl(start);
      return;
    }
    track('explore_result_click', { start, size: list.length, source: 'row' });
    window.location.href = `${rootUrl()}?set=explore`;
  };

  /* ---------------------------------------------------------------- events */

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const plain = !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0;

    // A row tile: its row as a reel from that recipe (the whole collection for Neu / Viral).
    const open = target.closest('[data-explore-open]');
    if (open && main.contains(open) && plain) {
      const rowSet = open.closest('[data-explore-set]');
      if (!rowSet) return;
      event.preventDefault();
      const handles = Array.from(rowSet.querySelectorAll('[data-explore-open]')).map((a) => a.dataset.handle);
      const label = rowSet.dataset.setLabel || tr('reels.from_explore');
      openReel({
        opener: open,
        collection: rowSet.dataset.setCollection || '',
        start: open.dataset.handle,
        title: label,
        source: 'row',
        scope: rowSet,
        fallback: () => openInFeed(handles, open.dataset.handle, label),
      });
      return;
    }

    // Category circles, collection cards, "Alle ansehen", the directory: that collection's page.
    const link = target.closest('a[href*="/collections/"]');
    const handle = link && main.contains(link) && plain ? collectionOf(link) : '';
    if (handle) {
      const kind = link.matches('.vhp-story-circle') ? 'circle' : link.matches('.ex-card') ? 'card' : link.matches('.explore-row__all') ? 'all' : 'list';
      if (kind === 'circle') markSeen(handle, link.dataset.count);
      track('explore_category_click', { handle, source: kind });
      // The link itself, unless it names another collection (data-explore-feed): then the one its count is from.
      const page = `${rootUrl()}collections/${handle}`;
      if (new URL(link.href, location.href).pathname !== page) {
        event.preventDefault();
        window.location.href = page;
      }
      return;
    }

    // A plain recipe link (the directory's list of all recipes): the recipe sheet on top of Explore.
    const recipe = target.closest('a[href*="/blogs/rezepte/"]');
    if (recipe && main.contains(recipe) && plain && window.vhpRecipeSheet) {
      event.preventDefault();
      window.vhpRecipeSheet.open(recipe.href);
      return;
    }

    if (!window.vhpSearch) return;

    // Quick chips and range tiles: straight to the results with that filter.
    const quick = target.closest('[data-quick]');
    if (quick && main.contains(quick) && plain) {
      event.preventDefault();
      const [key, value] = quick.dataset.quick.split(/:(.*)/);
      const init = { view: 'results' };
      init[key] = key === 'protein' || key === 'time' ? Number(value) : value;
      track('explore_quick_filter', { filter: quick.dataset.quick, source: quick.matches('.ex-range') ? 'tile' : 'chip' });
      window.vhpSearch.open(init);
      return;
    }

    if (target.closest('[data-explore-filters]')) {
      window.vhpSearch.open({ view: 'results' });
      window.vhpSearch.showFilters?.();
    }
  });

  window.addEventListener('vhp:likes-changed', paintLiked);
  // Back from the feed via bfcache: likes may have changed there.
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      paintLiked();
      paintSeen();
    }
  });

  paintLiked();
  paintSeen();
  // The search core loads after this file (both deferred), so wait for it.
  const start = () =>
    window.vhpSearchCore?.load().then(() => {
      paintRangeCounts();
      paintCounts();
    }, () => {});
  if (window.vhpSearchCore) start();
  else if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  // Switched to in-page (assets/app-router.js) from a page without the search: load it now.
  else window.vhpSearchLoad?.().then(start, () => {});
})();
